import {
	type ApplicationEdition,
	UNLICENSED,
	FREE_EDITION,
} from '@atlassian/jira-shared-types/src/edition.tsx';

export const publishFeatureDisabled = (edition?: ApplicationEdition) =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	edition && ([UNLICENSED, FREE_EDITION] as ApplicationEdition[]).includes(edition);
